// src/App.jsx
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import ImportarImoveis from './pages/ImportarImoveis';
import Imoveis from './pages/Imoveis';
import ImovelDetail from './pages/ImovelDetail';
// import Header from './components/Header';
import Sidebar from './components/Sidebar';
import ProtectedRoute from './components/ProtectedRoute';
import Processamentos from './pages/Processamentos';
import ProcessamentoDetail from './pages/ProcessamentoDetail';
import './App.css';
import ClienteDetail from './pages/ClienteDetail';
import Campanhas from './pages/Campanhas';
import NewCampaign from './pages/NewCampaign';
import EventosClientePage from './pages/EventosClientePage';
import Etiquetas from './pages/Etiquetas';
import Clientes from './pages/Clientes';
import BuscarProprietarios from './pages/BuscarProprietarios';
import TestMask from './components/TestMask';
import Vendas from './pages/Vendas';
import ChecagensListPage from './pages/checagens/ChecagensListPage';
import ChecagemDetailPage from './pages/checagens/ChecagemDetailPage';
import ChecagemImovelWorkPage from './pages/checagens/ChecagemImovelWorkPage';

const AppRoutes = () => {
  const location = useLocation();
  const isLogin = location.pathname === '/login';
  const [sidebarWidth, setSidebarWidth] = useState(250);

  return (
    <>
      <div className="main-layout">
        {!isLogin && <Sidebar onCollapseChange={setSidebarWidth} />}
        <div className="main-content" style={{ marginLeft: isLogin ? 0 : sidebarWidth }}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/importar_imoveis" element={<ImportarImoveis />} />
              <Route path="/imoveis" element={<Imoveis />} />
              <Route path="/imoveis/:id" element={<ImovelDetail />} />
              <Route path="/clientes" element={<Clientes />} />
              <Route path="/clientes/:id" element={<ClienteDetail />} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/processamentos" element={<Processamentos />} />
              <Route path="/processamentos/:id" element={<ProcessamentoDetail />} />
              <Route path="/campanhas" element={<Campanhas />} />
              <Route path="/campanhas/new" element={<NewCampaign />} />
              <Route path="/eventos-cliente" element={<EventosClientePage />} />
              <Route path="/etiquetas" element={<Etiquetas />} />
              <Route path="/buscar_proprietarios" element={<BuscarProprietarios />} />
              <Route path="/vendas" element={<Vendas />} />
              <Route path="/test-mask" element={<TestMask />} />
              <Route path="/checagens" element={<ChecagensListPage />} />
              <Route path="/checagens/:id" element={<ChecagemDetailPage />} />
              <Route path="/checagens/imovel/:ciid/work" element={<ChecagemImovelWorkPage />} />
            </Route>
          </Routes>
        </div>
      </div>
      
    </>
  );
};

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}


export default App;
